import { render, staticRenderFns } from "./CartMini.vue?vue&type=template&id=0045b4ea&"
import script from "./CartMini.vue?vue&type=script&lang=ts&"
export * from "./CartMini.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Buildserver\\Agent01\\_work\\1030\\s\\JCD.Retail.Webshop\\App\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0045b4ea')) {
      api.createRecord('0045b4ea', component.options)
    } else {
      api.reload('0045b4ea', component.options)
    }
    module.hot.accept("./CartMini.vue?vue&type=template&id=0045b4ea&", function () {
      api.rerender('0045b4ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/webshop/components/cart/CartMini.vue"
export default component.exports